<template lang="pug" src="./html/InstagramCodesQRARCodes-Body.pug"></template>

<script>
  import ArticleItemBase from './ArticleItemBase'

  export default {
    extends: ArticleItemBase,
    mounted () {
      this.setupVideo('267015225', 'https://player.youku.com/embed/XNDAxNDU2NTU3Mg==')
      this.setupVideo('267018667', 'https://player.youku.com/embed/XNDAxNDU2NTk5Mg==', this.$refs.video_player2)
    }
  }
</script>

<style scoped>
    a {
        color: #FFFFFF;
    }
    .img {
        background-color: #FFFFFF;
        color: #9a1599;
    }
    .img h2 {
        color: #9a1599;
        padding: 1.2em 0 .2em 0;
    }
    .img img {
        margin-top: 0.55em;
    }
    .img.feast-example {
        padding: 0.1em 0 1.1em 0;
    }
</style>
